stateBranchesListDropdown = document.querySelector('.state-branches-list-map--grid #stateBranchesDropdown');
if (stateBranchesListDropdown != null) {
  stateBranchesListDropdown.addEventListener('change', (e) => {
    if (stateBranchesListDropdown != null && stateBranchesListDropdown.value != '') {
      window.location.href = stateBranchesListDropdown.value;
    }
  });
}
